import { useCallback, useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../redux/hook';
import moment from 'moment';
// import { renewTokenForSingpassLogin } from '../redux/slices/authentication-slice';
import config from '../config';
import { updateExpiredIn } from '../redux/slices/authentication-slice';

function useCheckTokenExpiry() {

  const AppDispatch = useAppDispatch();

  const expiredInTimeStamp = useAppSelector(state => state.auth.AuthenticationSlice.expiredIn);
  const isSingPass = useAppSelector(state => state.auth.AuthenticationSlice.isSingPass);
  const singpassToken = useAppSelector(state => state.auth.AuthenticationSlice.singpassToken);

  

  const singpassRenewalCheckingProcess = useCallback(()=>{
    const currentTimeStamp = moment().unix();
    // const renewTimeStamp = moment(Number(expiredInTimeStamp) * 1000).subtract(5, 'minutes').unix(); //8 mins before the expiry timestamp

    if (!config.isLocalhost && expiredInTimeStamp && currentTimeStamp >= expiredInTimeStamp) {
      console.log("--->AUTH ---- TOKEN EXPIRED");
      AppDispatch(updateExpiredIn(undefined));//to prevent at logout page still spamming redirection
      window.location.href = "/transfer/logout?spToken=" + singpassToken;
    }
    // else if (!isNaN(renewTimeStamp) && currentTimeStamp >= renewTimeStamp) {
    //   console.log("RENEW TOKEN AND EXPIRY token");
    //   AppDispatch(renewTokenForSingpassLogin({ singpass_code: singpassToken })).catch(e => {
    //     window.location.href = "/transfer/logout?spToken=" + singpassToken;
    //   })
    // }


  },[AppDispatch, expiredInTimeStamp, singpassToken])

  //CHECK EXPIRY OF TIMESTAMP
  useEffect(() => {
    let intervalID: number;
    intervalID = window.setInterval(()=>{
      console.log("CHECK SINGPASS TOKEN");
      singpassRenewalCheckingProcess();
    },1000); //every 60 seconds

    return () => {
      clearInterval(intervalID);
    }


  }, [AppDispatch, expiredInTimeStamp, isSingPass, singpassRenewalCheckingProcess, singpassToken]);

  useEffect(() => {
    singpassRenewalCheckingProcess()
  }, [])

  useEffect(() => {
      console.log("expiredInTimestamp:", expiredInTimeStamp);
  }, [expiredInTimeStamp])
}

export default useCheckTokenExpiry
